import { render, staticRenderFns } from "./likeDislike.vue?vue&type=template&id=6f4b3421&"
import script from "./likeDislike.vue?vue&type=script&lang=ts&"
export * from "./likeDislike.vue?vue&type=script&lang=ts&"
import style0 from "./likeDislike.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports